"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var HBFileAttachmentProgressBar = function HBFileAttachmentProgressBar(_ref) {
  var percent = _ref.percent,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(PercentageBar, {
    style: {
      width: "".concat(percent, "%")
    }
  }));
};
var _default = exports["default"] = HBFileAttachmentProgressBar;
var PercentageBar = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachmentProgressBar__PercentageBar",
  componentId: "sc-a8n21n-0"
})(["height:4px;background:", ";transition:all 0.2s linear;"], _colors["default"].blue20);
//# sourceMappingURL=HBFileAttachmentProgressBar.js.map